function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";
import VerticalTimerTabsAdvancedConfig from "segments/desktop/core-components/vertical-timer-tabs/fields-advanced-config";
import TitleAdvancedConfig from "segments/desktop/core-components/title/advanced-field-config";
import AssetAdvancedConfig from "components/core/asset/advanced-field-config";
import FullWithBulletsParagraphAdvancedConfig from "segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-advanced-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread(_object_spread_props(_object_spread({}, SharedAdvancedFieldsConfig), {
        tabsTitle: {
            type: FIELD_TYPES.NESTED,
            label: "Title",
            fields: TitleAdvancedConfig
        },
        advancedTitleConfig: _object_spread_props(_object_spread({}, VerticalTimerTabsAdvancedConfig.title), {
            label: "Tab Title"
        }),
        prerenderTabs: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Prerender tabs"
        },
        tabContent: {
            type: FIELD_TYPES.NESTED,
            label: "Tab Content",
            fields: FullWithBulletsParagraphAdvancedConfig.fields
        },
        arrowSize: VerticalTimerTabsAdvancedConfig.arrowSize
    }), AssetAdvancedConfig)
};
